'use strict';

import addProductToCart from './product/addToCart';
import page from '../page';
import login from '../login';
import util from '../util';
import account from './account';
import minicart from '../minicart';

function changeQuantity () {
    $('.quantity-container select').change(function () {
        var quantity = $(this).find('option:selected').val();

        $('.option-quantity-desired input').val(quantity);
        $(this).closest('form').find('.update-item').click();
    });
}

function addItemToBag() {
    $(document).on('click', 'button.add-all-to-cart', function(e) {
        e.preventDefault();

        $(document).find('button[name$="_addToCart"]').each(function(e) {
            $(this).click();
        });
    });

    $(document).on('click', 'button[name$="_addToCart"]', function(e) {
        e.preventDefault();

        var $form = $(this).closest('form');
        var divError = $form.find('div.product-error');

        $.ajax({
            type: 'POST',
            url: util.ajaxUrl(Urls.wishlistAddToCart),
            data: $form.serialize(),
            success: function(response) {
                if (response.error) {
                    divError.html(response.error);
                } else {
                    minicart.show(response);
                }
            }
        });
    });
}

function initShareWishListEvents() {
    $(document).on('submit', '.share-wishlist-content .share-wishlist-form', function (e) {
        e.preventDefault();

        var emailAddress = $('.share-wishlist-content .share-wishlist-form input[name="email"]').val();
        var parentdiv = '.share-wishlist-content';
        
        $.ajax({
            type: 'POST',
            url: $('.share-wishlist-form').attr('action'),
            data: {
                email: emailAddress
            },
            success: function (response) {
                $(parentdiv).html(response);
            }
        });

    });
}


export default {
    init: function () {
        addProductToCart();
        changeQuantity();
        addItemToBag();
        initShareWishListEvents();

        $('#editAddress').on('change', function () {
            page.redirect(util.appendParamToURL(Urls.wishlistAddress, 'AddressID', $(this).val()));
        });

        //add js logic to remove the , from the qty feild to pass regex expression on client side
        $('.option-quantity-desired input').on('focusout', function () {
            $(this).val($(this).val().replace(',', ''));
        });

        login.init();
        account.initMobileMenu();
    }
};
